import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router  } from "@angular/router";
import { FormBuilder, FormGroup } from '@angular/forms';
import { loadingFade } from '../../animacoes';
import * as moment from 'moment';

import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ProfissionalService } from '../services/profissional.service';
import { VeiculoService } from '../services/veiculo.service';
import { CheckCalibragemService } from '../services/check-calibragem.service';

@Component({
  selector: 'app-calibragem-pneus-ver',
  templateUrl: './calibragem-pneus-ver.component.html',
  styleUrls: ['./calibragem-pneus-ver.component.css'],
	animations: [loadingFade]
})
export class CalibragemPneusVerComponent implements OnInit {
  public loading;
  public submitting = false;
  public inicioPeriodo;

	public formChecklist: FormGroup;

  public agencias = [];
  public unidades = [];
  public profissionais = [];
  public veiculos = [];

  public check_calibragem_id = null;
  public profissional = null;

    //filtro
    public cliente_id___cliente = null;
    public unidade_id___unidade = null;
    public veiculo_id___veiculo = null;
    public check_calibragem_turno___periodo = null;
    public check_calibragem_status___status = null;
    public check_calibragem_data___data_i = null;
    public check_calibragem_data___data_f = null;
    public profissional_id___profissional = null;

  constructor(private authSvc: AuthService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private clienteSvc: ClienteService,
    private unidadeSvc: UnidadeService,
    private profissionalSvc: ProfissionalService ,
    private veiculoSvc: VeiculoService,
    private checkcalibragemSvc: CheckCalibragemService) { }

  ngOnInit() {
    this.pegaAgencias();
    this.pegaProfissionais();
    this.criaForm();
    this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {


        var splitFiltro = params.id.split("?");

        if(splitFiltro[1] !== undefined){
          
          var splitfiltro = splitFiltro[1].split("&");
          for (let f in splitfiltro) {

            var loSplitValor = splitfiltro[f].split("=");

            switch(loSplitValor[0]) { 
              case "cliente_id___cliente": { 
                 this.cliente_id___cliente = loSplitValor[1];
                 break; 
              } 
              case "unidade_id___unidade": { 
                this.unidade_id___unidade = loSplitValor[1];
                 break; 
              } 
              case "veiculo_id___veiculo": { 
                this.veiculo_id___veiculo = loSplitValor[1];
                 break; 
              } 
              case "check_calibragem_turno___periodo": { 
                this.check_calibragem_turno___periodo = loSplitValor[1];
                 break; 
              }     
              case "check_calibragem_data___data_i": { 
                this.check_calibragem_data___data_i = loSplitValor[1];
                 break; 
              }      
              case "check_calibragem_data___data_f": { 
                this.check_calibragem_data___data_f = loSplitValor[1];
                 break; 
              }      
              case "profissional_id___profissional": { 
                this.profissional_id___profissional = loSplitValor[1];
                 break; 
              }                                                            
           }

          }


        }  

				this.check_calibragem_id = params.id;
				this.checkcalibragemSvc.getCheckCalibragem(params.id).then((data: any) => {
          this.pegaUnidadesByAgencia(data.cliente_id);
          this.pegaVeiculosByUnidade(data.unidade_id);
					this.preencheForm({
            check_calibragem_id:  data.check_calibragem_id,
            usuario_id:  data.usuario_id,
            check_calibragem_data:  moment(data.check_calibragem_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            check_calibragem_turno:  data.check_calibragem_turno,
            cliente_id:  data.cliente_id,
            unidade_id:  data.unidade_id,
            profissional_id:  data.profissional_id,
            veiculo_id:  data.veiculo_id,
            check_calibragem_ed_pressao: data.check_calibragem_ed_pressao,
            check_calibragem_ed_dot: data.check_calibragem_ed_dot,
            check_calibragem_et_pressao: data.check_calibragem_et_pressao,
            check_calibragem_et_dot: data.check_calibragem_et_dot,
            check_calibragem_dd_pressao: data.check_calibragem_dd_pressao,
            check_calibragem_dd_dot: data.check_calibragem_dd_dot,
            check_calibragem_dt_pressao: data.check_calibragem_dt_pressao,
            check_calibragem_dt_dot: data.check_calibragem_dt_dot,
            
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
    });
  }
  criaForm(){
    
    this.formChecklist = this.fb.group({
			check_calibragem_id: null,
			usuario_id: null,
      check_calibragem_data: [{value: null, disabled: true}],
      check_calibragem_turno: [{value: null, disabled: true}],
      cliente_id: [{value: null, disabled: true}],
      unidade_id: [{value: null, disabled: true}],
      profissional_id: [{value: null, disabled: true}],
      veiculo_id: [{value: null, disabled: true}],
      check_calibragem_ed_pressao: [{value: null, disabled: true}],
      check_calibragem_ed_dot: [{value: null, disabled: true}], 
      check_calibragem_et_pressao: [{value: null, disabled: true}],
      check_calibragem_et_dot: [{value: null, disabled: true}], 
      check_calibragem_dd_pressao: [{value: null, disabled: true}],
      check_calibragem_dd_dot: [{value: null, disabled: true}], 
      check_calibragem_dt_pressao: [{value: null, disabled: true}],
      check_calibragem_dt_dot: [{value: null, disabled: true}], 
    });
  }

  preencheForm(dados) {
		this.formChecklist.setValue(dados);
  }

  pegaAgencias(){
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.agencias = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaUnidadesByAgencia(agencia_id){
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), agencia_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }
  
  pegaVeiculosByUnidade(unidade_id){
    this.veiculoSvc.getByTipoVeiculo(unidade_id, 1).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  pegaProfissionais(){
    this.profissionalSvc.getProfissionais().then((data: any[]) => {
			this.profissionais = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  onClickVoltar(){

    let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
    params += "&unidade_id___unidade=" + this.unidade_id___unidade;
    params += "&veiculo_id___veiculo=" + this.veiculo_id___veiculo;
    params += "&check_calibragem_turno___periodo=" + this.check_calibragem_turno___periodo;
    params += "&check_calibragem_data___data_i=" + this.check_calibragem_data___data_i;
    params += "&check_calibragem_data___data_f=" + this.check_calibragem_data___data_f;
    params += "&profissional_id___profissional=" + this.profissional_id___profissional;

    this.router.navigate(['/home/calibragempneusfiltro/' + params]);

  }
}
